import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { e2eLocators, fakeSecretKey } from '../credential-forms.constants';
import { BackBlazeCredentialForm } from '../credential-forms.model';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-backblaze',
  templateUrl: './credential-form-backblaze.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardGroupComponent, CommonModule, FormGroupComponent, I18NextPipe, InputComponent, InputPasswordComponent, ReactiveFormsModule]
})
export class CredentialFormBackblazeComponent implements OnInit {
  @Input() form: BackBlazeCredentialForm;

  public readonly StorageType = StorageType;
  public readonly fakeSecretKey = fakeSecretKey;
  public readonly e2eLocators = e2eLocators;

  ngOnInit() {
    this.accountId.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.applicationKey.patchValue('');
      this.applicationKey.updateValueAndValidity();
    });
  }

  get accountId(): FormControl {
    return this.form.get('accountId') as FormControl;
  }

  get applicationKey(): FormControl {
    return this.form.get('applicationKey') as FormControl;
  }
}
